/* eslint-disable react-portal/no-window-location-assign */
import { Trans } from '@lingui/macro';
import { Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useGlobalDataService } from '../../services/ApiDataService';
import useSession from '../../stores/SessionStore';
import { rethrowError } from '../../utilities/RequestUtilities';
import AuthPanel from './AuthPanel';
import usePostLoginRedirect from './UsePostLoginRedirect';

export default function LogoutPage() {
    const dataService = useGlobalDataService();
    const [, sessionActions] = useSession();
    const [error, setError] = useState(false);
    const { doAndRestoreLastLocation } = usePostLoginRedirect();

    useEffect(() => {
        doLogout();

        async function doLogout() {
            try {
                await dataService.post(
                    '/ipm/auth/logout',
                    { idleSessionTimeExceeded: false },
                    null,
                    null,
                    rethrowError
                );

                // We need to "restore" the last-accessed location when logging out, because when we detect an invalid
                // session, we redirect to /logout (here) and then back to login. When logging out, we wipe out session
                // storage, so we need to restore our last location after it's wiped out.
                doAndRestoreLastLocation(() => sessionStorage.clear());
                sessionActions.clearSession();

                // do a full refresh to wipe any caches we have
                // also go to /login instead of SSO_LOGIN_REDIRECT
                // as SSO will just log you right back in...
                window.location.assign('/login');
            } catch (e) {
                setError(e);
            }
        }
    }, [dataService, sessionActions, doAndRestoreLastLocation]);

    return (
        <AuthPanel loading={!error}>
            {error && (
                <Typography variant="subtitle2" color="error">
                    <Trans>An error occurred logging you out</Trans>
                </Typography>
            )}
        </AuthPanel>
    );
}
